import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-scroll"
export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.scrollToBottom()
    
    // Observer pour détecter quand de nouveaux messages sont ajoutés
    this.observer = new MutationObserver(() => {
      this.scrollToBottom()
    })
    
    if (this.hasContainerTarget) {
      this.observer.observe(this.containerTarget, {
        childList: true,
        subtree: true
      })
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollToBottom() {
    const target = this.hasContainerTarget ? this.containerTarget : this.element
    if (target) {
      // Petit délai pour s'assurer que le contenu est rendu
      requestAnimationFrame(() => {
        target.scrollTop = target.scrollHeight
      })
    }
  }
}